// extracted by mini-css-extract-plugin
export default {"container":"vU-z","title":"wU-z","link":"xU-z"};